import crudAction from './actions'

/**
 * Platform-managed mailbox app passwords (stored on mailcow as
 * `iad_mail_password_<name>`; the API strips the prefix).
 *
 *   store.filter('mailboxAppPassword').action()          GET    /v1/users/mailbox_app_passwords/
 *   store.create('mailboxAppPassword').action({ name })  POST   /v1/users/mailbox_app_passwords/   -> { id, name, active, created, appPassword }
 *   store.delete('mailboxAppPassword').action(id)        DELETE /v1/users/mailbox_app_passwords/<id>/
 *
 * `appPassword` is only returned by the create call and never again.
 */
export default {
  name: 'mailboxAppPassword',
  namespace: 'users/mailbox_app_passwords',
  methods: [...crudAction],
}
